/* Bano:Bagi Clinic theme — vanilla JS, no dependencies */
(function () {
  'use strict';
  var T = window.theme || { routes: { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', root: '/' }, cartDrawer: true };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function formatMoney(cents) {
    var fmt = T.moneyFormat || 'R {{amount}}';
    var n = (cents / 100).toFixed(2).split('.');
    var withSep = function (sep, dec) { return n[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep) + dec + n[1]; };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return withSep('.', ',');
      if (k === 'amount_with_space_separator') return withSep(' ', ',');
      return withSep(',', '.');
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var panel = $('.drawer__panel', el);
    if (panel) setTimeout(function () { panel.focus(); }, 50);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.getAttribute('data-drawer-open'))); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); return; }
    var cartToggle = e.target.closest('[data-cart-toggle]');
    if (cartToggle && T.cartDrawer && !document.body.classList.contains('template-cart')) { e.preventDefault(); openDrawer(cartDrawer()); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });
  function cartDrawer() { return document.getElementById('CartDrawer'); }

  /* ---------- Search toggle ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-search-toggle]');
    if (!t) return;
    var bar = $('[data-search-bar]');
    if (!bar) return;
    e.preventDefault();
    bar.hidden = !bar.hidden;
    if (!bar.hidden) $('input[type="search"]', bar).focus();
  });

  /* ---------- Cart (AJAX + Section Rendering API) ---------- */
  function refreshCart(open) {
    return fetch(T.routes.root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = $('#CartDrawer', tmp);
        var current = cartDrawer();
        if (fresh && current) {
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          if (open || wasOpen) openDrawer(current);
        }
        return fetch(T.routes.cart + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart) return;
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
      });
  }

  function addToCart(formData, btn) {
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('disabled', ''); btn.setAttribute('aria-busy', 'true'); }
    return fetch(T.routes.cartAdd + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add to cart');
        if (btn) btn.innerHTML = (T.strings && T.strings.added) || 'Added';
        return refreshCart(T.cartDrawer);
      })
      .catch(function (err) { alertInline(btn, err.message); })
      .finally(function () {
        if (!btn) return;
        setTimeout(function () { btn.innerHTML = label; btn.removeAttribute('disabled'); btn.removeAttribute('aria-busy'); }, 1200);
      });
  }
  function alertInline(btn, msg) {
    if (!btn) return;
    var p = document.createElement('p');
    p.className = 'form-errors';
    p.style.marginTop = '10px';
    p.textContent = msg;
    btn.parentNode.appendChild(p);
    setTimeout(function () { p.remove(); }, 4000);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-quick-add], [data-product-form]')) return;
    if (!window.fetch) return;
    e.preventDefault();
    addToCart(new FormData(form), $('[type="submit"]', form));
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    e.preventDefault();
    var drawer = cartDrawer();
    if (drawer) drawer.setAttribute('aria-busy', 'true');
    fetch(T.routes.cartChange + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(btn.getAttribute('data-cart-change'), 10), quantity: parseInt(btn.getAttribute('data-qty'), 10) })
    }).then(function () { return refreshCart(false); })
      .finally(function () { if (drawer) drawer.removeAttribute('aria-busy'); });
  });

  /* ---------- Product page ---------- */
  function initProduct(root) {
    // Gallery thumbnails
    var gallery = $('[data-gallery]', root);
    if (gallery) {
      var stage = $('.gallery__main', gallery);
      var imgs = $$('.gallery__main img', gallery);
      var thumbs = $$('[data-thumb]', gallery);
      var cur = Math.max(0, imgs.findIndex(function (im) { return im.classList.contains('is-active'); }));
      var counter = null;
      if (imgs.length > 1) {
        counter = document.createElement('span');
        counter.className = 'gallery__count';
        counter.setAttribute('aria-hidden', 'true');
        stage.appendChild(counter);
      }
      function show(i, dir) {
        if (!imgs.length) return;
        i = (i + imgs.length) % imgs.length;
        imgs.forEach(function (img, n) {
          img.classList.toggle('is-active', n === i);
          img.classList.remove('slide-from-left', 'slide-from-right');
          img.style.transform = '';
        });
        if (dir) { void imgs[i].offsetWidth; imgs[i].classList.add(dir > 0 ? 'slide-from-right' : 'slide-from-left'); }
        cur = i;
        var thumb = thumbs.filter(function (t) { return +t.getAttribute('data-thumb') === i; })[0];
        thumbs.forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
        if (thumb) {
          var row = thumb.parentNode;
          if (row.scrollWidth > row.clientWidth) row.scrollTo({ left: thumb.offsetLeft - (row.clientWidth - thumb.offsetWidth) / 2, behavior: 'smooth' });
          var lbl = $('[data-media-label]', gallery);
          if (lbl && thumb.getAttribute('data-label')) lbl.textContent = thumb.getAttribute('data-label');
        }
        if (counter) counter.textContent = (i + 1) + ' / ' + imgs.length;
      }
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var i = parseInt(thumb.getAttribute('data-thumb'), 10);
          show(i, i > cur ? 1 : i < cur ? -1 : 0);
        });
      });
      if (counter) counter.textContent = (cur + 1) + ' / ' + imgs.length;

      // Swipe left/right on the main image (touch and pen)
      if (imgs.length > 1) {
        var x0 = null, y0 = null, dx = 0, locked = null;
        stage.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) return;
          x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0; locked = null;
        }, { passive: true });
        stage.addEventListener('touchmove', function (e) {
          if (x0 === null) return;
          var mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
          if (locked === null && (Math.abs(mx) > 8 || Math.abs(my) > 8)) locked = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
          if (locked !== 'x') return;
          if (e.cancelable) e.preventDefault();
          dx = mx;
          imgs[cur].style.transition = 'none';
          imgs[cur].style.transform = 'translateX(' + dx + 'px)';
        }, { passive: false });
        function end() {
          if (x0 === null) return;
          var a = imgs[cur];
          a.style.transition = '';
          var w = stage.clientWidth || 300;
          if (locked === 'x' && Math.abs(dx) > Math.min(60, w * 0.18)) show(cur + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
          else a.style.transform = '';
          x0 = y0 = null; dx = 0; locked = null;
        }
        stage.addEventListener('touchend', end);
        stage.addEventListener('touchcancel', end);
        // Keyboard arrows when the gallery has focus
        gallery.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); show(cur + 1, 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); show(cur - 1, -1); }
        });
      }
    }

    // Quantity
    var qty = $('.qty input', root);
    if (qty) {
      $('[data-qty-minus]', root).addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      $('[data-qty-plus]', root).addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }

    // Variants
    var form = $('[data-product-form]', root);
    var variantsEl = $('[data-variants]', root);
    if (form && variantsEl) {
      var variants = JSON.parse(variantsEl.textContent);
      form.addEventListener('change', function (e) {
        if (!e.target.matches('[data-option]')) return;
        var selected = $$('fieldset.variant-picker', form).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); });
        var btn = $('[data-add-btn]', form);
        if (!match) { btn.setAttribute('disabled', ''); return; }
        $('[data-variant-id]', form).value = match.id;
        if (match.available) { btn.removeAttribute('disabled'); btn.innerHTML = T.strings.addToCart + ' — <span data-add-price>' + formatMoney(match.price) + '</span>'; }
        else { btn.setAttribute('disabled', ''); btn.textContent = T.strings.soldOut; }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
        if (match.featured_media) {
          var pos = match.featured_media.position - 1;
          var thumb = $('[data-thumb="' + pos + '"]', root);
          if (thumb) thumb.click();
        }
        var priceEl = $('.product__price .price__now', root);
        if (priceEl) priceEl.textContent = formatMoney(match.price);
      });
    }

    // Sticky add to cart (mobile)
    var sticky = $('[data-sticky-atc]');
    var mainBtn = $('[data-add-btn]', root);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(mainBtn);
      $('[data-sticky-add]', sticky).addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else mainBtn.click();
      });
    }
  }
  $$('[data-product]').forEach(initProduct);

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || el.children.length) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = $('[data-recommendations]', tmp);
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML; else el.remove();
    });
  });

  /* ---------- Testimonial slider ---------- */
  $$('[data-slider]').forEach(function (s) {
    var track = $('[data-slider-track]', s);
    if (!track) return;
    var step = function () { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 20 : 300; };
    var prev = $('[data-slider-prev]', s), next = $('[data-slider-next]', s);
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* ---------- Ranges explorer (tabs) ---------- */
  $$('[data-explorer]').forEach(function (root) {
    var tabs = $$('[data-explorer-tab]', root);
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    }
    tabs.forEach(function (t) {
      /* Tabs are links to the range page; hovering or focusing previews the panel. */
      if (window.matchMedia('(hover: hover)').matches) t.addEventListener('mouseenter', function () { select(t); });
      t.addEventListener('focus', function () { select(t); });
    });
  });

  /* ---------- Concern filter pills (range pages) ---------- */
  $$('[data-concern-filter]').forEach(function (root) {
    var pills = $$('[data-concern]', root);
    var items = $$('[data-concern-item]', root);
    var count = $('[data-concern-count]', root);
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        var c = p.getAttribute('data-concern');
        pills.forEach(function (x) { x.classList.toggle('is-active', x === p); x.setAttribute('aria-pressed', x === p ? 'true' : 'false'); });
        var shown = 0;
        items.forEach(function (li) { var on = c === 'all' || li.getAttribute('data-concern-item') === c; li.hidden = !on; if (on) shown++; });
        if (count) count.textContent = shown + (shown === 1 ? ' mask' : ' masks');
      });
    });
  });

  /* ---------- Collection filters: auto-submit ---------- */
  $$('[data-facets-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-facet-input]')) form.submit();
    });
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el, i) { el.style.transitionDelay = (i % 5) * 60 + 'ms'; io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    $$('.reveal', e.target).forEach(function (el) { el.classList.add('is-in'); });
    $$('[data-product]', e.target).forEach(initProduct);
  });
})();

/* ---------- Pack picker (bundle-picker snippet) ---------- */
(function () {
  function money(c) { return 'R ' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function init(root) {
    if (root.__bundle) return; root.__bundle = true;
    var mix = root.getAttribute('data-mix') === 'true';
    var current = root.getAttribute('data-current');
    var tiers = [].slice.call(root.querySelectorAll('[data-tier]'));
    var rows = [].slice.call(root.querySelectorAll('[data-mix-row]'));
    var inputs = root.querySelector('[data-bundle-inputs]');
    var btn = root.querySelector('[data-bundle-add]');
    var saving = root.querySelector('[data-bundle-saving]');
    var step = Math.max(1, parseInt(root.getAttribute('data-step'), 10) || 1);
    function tier() { var t = tiers.filter(function (x) { return x.querySelector('input').checked; })[0] || tiers[0]; return { q: +t.getAttribute('data-q'), d: +t.getAttribute('data-d'), el: t }; }
    function val(r) { return Math.max(0, parseInt(r.querySelector('[data-mix-input]').value, 10) || 0); }
    function set(r, n) { r.querySelector('[data-mix-input]').value = Math.max(0, Math.round(n / step) * step); }
    function reset() {
      var t = tier();
      rows.forEach(function (r) { set(r, r.getAttribute('data-id') === current ? t.q : 0); });
      if (mix && !rows.some(function (r) { return r.getAttribute('data-id') === current; }) && rows[0]) set(rows[0], t.q);
    }
    function render() {
      var t = tier();
      tiers.forEach(function (x) { x.classList.toggle('is-selected', x === t.el); });
      var lines = [], total = 0, full = 0;
      if (mix) {
        rows.forEach(function (r) { var n = val(r); r.classList.toggle('has-qty', n > 0); if (n) { lines.push([r.getAttribute('data-id'), n]); total += n; full += n * (+r.getAttribute('data-price')); } });
        var sets = Math.max(1, Math.round(t.q / step)), left = Math.max(0, (t.q - total) / step);
        rows.forEach(function (r) {
          r.querySelector('[data-mix-plus]').disabled = total + step > t.q;
          r.querySelector('[data-mix-minus]').disabled = val(r) < step;
        });
        root.querySelector('[data-mix-count]').textContent = total;
        root.querySelector('[data-mix-target]').textContent = t.q;
        var t2 = root.querySelector('[data-mix-target-2]'); if (t2) t2.textContent = t.q;
        var se = root.querySelector('[data-mix-sets]'); if (se) se.textContent = sets;
        var ss = root.querySelector('[data-mix-sets-s]'); if (ss) ss.textContent = sets === 1 ? '' : 's';
        root.querySelector('[data-mix-bar]').style.width = Math.min(100, total / t.q * 100) + '%';
        var hint = root.querySelector('[data-mix-hint]');
        hint.textContent = total < t.q ? 'Add ' + left + ' more set' + (left === 1 ? '' : 's') + ' of ' + step + ' to complete your ' + t.q + '-mask pack.' : total > t.q ? 'Remove ' + ((total - t.q) / step) + ' set' + ((total - t.q) === step ? '' : 's') + ' of ' + step + ' to match your ' + t.q + '-mask pack.' : 'Your pack is complete.';
        hint.classList.toggle('is-done', total === t.q);
      } else {
        lines.push([current, t.q]); total = t.q;
        full = +(root.getAttribute('data-unit') || 0) * t.q;
      }
      inputs.innerHTML = lines.map(function (l, i) { return '<input type="hidden" name="items[' + i + '][id]" value="' + l[0] + '"><input type="hidden" name="items[' + i + '][quantity]" value="' + l[1] + '">'; }).join('');
      var pay = Math.round(full * (100 - t.d) / 100);
      var ok = total === t.q;
      btn.disabled = !ok;
      btn.innerHTML = ok ? 'Add ' + t.q + ' masks — ' + money(pay || 0) : (total < t.q ? (t.q - total) + ' more to go' : 'Too many selected');
      if (t.d > 0 && ok && full) { saving.hidden = false; saving.textContent = "You're saving " + money(full - pay) + ' on this pack'; } else saving.hidden = true;
    }
    tiers.forEach(function (t) { t.querySelector('input').addEventListener('change', function () { reset(); render(); }); });
    rows.forEach(function (r) {
      r.querySelector('[data-mix-minus]').addEventListener('click', function () { set(r, val(r) - step); render(); });
      r.querySelector('[data-mix-plus]').addEventListener('click', function () { var t = tier(), tot = rows.reduce(function (a, x) { return a + val(x); }, 0); if (tot + step <= t.q) set(r, val(r) + step); render(); });
      r.querySelector('[data-mix-input]').addEventListener('input', render);
    });
    var form = root.querySelector('[data-bundle-form]');
    form.addEventListener('submit', function (e) {
      if (btn.disabled) { e.preventDefault(); e.stopImmediatePropagation(); root.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }, true);
    reset(); render();
  }
  function all(scope) { [].forEach.call((scope || document).querySelectorAll('[data-bundle]'), init); }
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', function () { all(); });
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();
